// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-external-id-column {
  width: 20%;
}

.contact-temlate-variables-column {
  text-align: left !important;
  width: 75%;
}

.contact-template-variables-cell-content {
  max-width: 100%;
  overflow-y: auto;
  line-break: auto;
  height: 6rem;
  max-height: 6rem;
  padding-right: 1rem;
  padding-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/mailing/mailing-main/mailing-list/mailing-item-info/MailingRecipients/MailingRecipienstContactsWithVariables/MailingRecipientsContactsWithVariablesList.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".contact-external-id-column {\r\n  width: 20%;\r\n}\r\n\r\n.contact-temlate-variables-column {\r\n  text-align: left !important;\r\n  width: 75%;\r\n}\r\n\r\n.contact-template-variables-cell-content {\r\n  max-width: 100%;\r\n  overflow-y: auto;\r\n  line-break: auto;\r\n  height: 6rem;\r\n  max-height: 6rem;\r\n  padding-right: 1rem;\r\n  padding-left: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
